import usePlausible from 'hooks/usePlausible'
import { useDispatch, useSelector } from 'react-redux'

import { selectPathName } from '../../../accessors/index'
import { postAndSelectSubsidiary, savePrevPath } from '../../../actions/index'
import { saveSubsidiary } from '../../../utils/helpers'
import { HotelSelector } from './HotelSelector'

const HotelSwitcher = ({ children }) => {
  const { postEvent, plausibleEvents } = usePlausible()

  const dispatch = useDispatch()

  const pathName = useSelector(selectPathName)

  function handleSelect(subsidiary) {
    postEvent(plausibleEvents.SwitchHotel, {
      subsidiaryIdToSwitch: subsidiary.subsidiaryId
    })
    dispatch(savePrevPath(pathName))
    saveSubsidiary(subsidiary)
    dispatch(postAndSelectSubsidiary(subsidiary.subsidiaryId))
  }

  return <HotelSelector handleSelect={handleSelect}>{children}</HotelSelector>
}

export default HotelSwitcher
